import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SCHOOLS_ENDPOINT } from "../../Constants/Endpoints";
import TableTemplate from "../Table/TableTemplate";
import "./SchoolSelection.scss";

const SchoolSelection = ({
  schoolSelected,
  setSchoolSelected,
  schoolSelection,
  buttonChangeDisabled,
  setSchoolSelection,
  onClickChange,
}) => {
  const tableSchoolsRef = useRef(null);
  const [t] = useTranslation();
  const [highlightSchoolValues, setHighlightSchoolValues] = useState([]);
  const [highlightKey] = useState("id");

  const schoolColumns = [
    {
      name: "schoolNumber",
      headerCaption: t("SchoolNumber"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "schoolDeliveryType",
      headerCaption: t("SchoolType"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "name",
      headerCaption: t("Name"),
      size: "large",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "actions",
      headerCaption: "",
      size: "small",
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) => {
        return (
          <Button
            className="button-selected"
            disabled={highlightSchoolValues[0] === x.id}
            onClick={() => {
              setSchoolSelected(x);
              setHighlightSchoolValues([x.id]);
              setSchoolSelection(false);
            }}
          >
            {highlightSchoolValues[0] === x.id ? t("Selected") : t("Select")}
          </Button>
        );
      },
    },
  ];

  return (
    <div className="school-selection-wrapper">
      <div className="banner-wrapper">
        <div className="banner-wrapper-title-wrapper">
          <div className="banner-wrapper-title">{t("School")}</div>
          <div className="banner-wrapper-subtitle">
            {schoolSelected ? schoolSelected.name : t("NotSelected")}
          </div>
        </div>
        <Button
          className="button-banner"
          disabled={buttonChangeDisabled}
          onClick={() => onClickChange()}
        >
          {highlightSchoolValues.length === 0 ? t("Select") : t("Change")}
        </Button>
      </div>
      <div
        className={`table-selection-wrapper${schoolSelection ? ` show` : ``}`}
      >
        {schoolSelection && (
          <TableTemplate
            ref={tableSchoolsRef}
            title={t("Schools")}
            pageSize={5}
            highlightValues={highlightSchoolValues}
            highlightKey={highlightKey}
            endpoint={SCHOOLS_ENDPOINT}
            columns={schoolColumns}
            uniqueId="schoolNumber"
            paginator={true}
            showSizeSelector={false}
          />
        )}
      </div>
    </div>
  );
};

export default SchoolSelection;
